<div class="content" fxLayout="column" fxLayout.sm="column" fxLayout.xs="column" fxLayoutGap="16px"
    [@routeAnimation]="true">
    <div *ngIf="tableType === 'Email'" style="padding: 15px; ">
        <button mat-raised-button color="primary" [disabled]="selection.selected.length === 0"
            (click)="onComposeEmail()">
            Compose Award/Decline Email</button>
    </div>
    <div *ngIf="tableType !== 'Email'" style="padding: 15px; ">
        <button mat-raised-button color="primary" [disabled]="selection.selected.length === 0"
            (click)="onCloseRequest()">
            Close selected request(s)</button>
    </div>
    <div class="filter">
        <mat-form-field>
            <input matInput (keyup)="applyFilter($event.target.value)" placeholder="Filter">
        </mat-form-field>
    </div>

    <div class="mat-elevation-z8 table-container">
        <mat-table class="mat-elevation-z8" #table [dataSource]="dataSource" matSort>
            <ng-container matColumnDef="select">
                <mat-header-cell *matHeaderCellDef>
                    <mat-checkbox (change)="$event ? masterToggle($event) : null" [checked]="isAllChecked"
                        [indeterminate]="isIndeterminate">
                    </mat-checkbox>
                </mat-header-cell>
                <mat-cell *matCellDef="let row">
                    <mat-checkbox (click)="$event.stopPropagation()" (change)="$event ? requestChecked(row) : null"
                        [checked]="selection.isSelected(row)"  *ngIf="isVisible(row)">
                    </mat-checkbox>
                </mat-cell>
            </ng-container>

            <ng-container matColumnDef="requestNo">
                <mat-header-cell style="flex-grow: 2;" *matHeaderCellDef mat-sort-header> Request No </mat-header-cell>
                <mat-cell style="flex-grow: 2;" *matCellDef="let row"> {{row.requestNo}} </mat-cell>
            </ng-container>

            <ng-container matColumnDef="reassign">
                <mat-header-cell style="flex-grow: 2;" *matHeaderCellDef mat-sort-header> Is Reassigned?
                </mat-header-cell>
                <mat-cell style="flex-grow: 2;" *matCellDef="let row"> {{row.reassign}} </mat-cell>
            </ng-container>

            <ng-container matColumnDef="projectName">
                <mat-header-cell style="flex-grow: 3;" *matHeaderCellDef mat-sort-header> Project Name
                </mat-header-cell>
                <mat-cell style="flex-grow: 3;" *matCellDef="let row"> {{row.formName}} </mat-cell>
            </ng-container>

            <!-- <ng-container matColumnDef="formName">
                <mat-header-cell style="flex-grow: 3;" *matHeaderCellDef mat-sort-header> Request Name
                </mat-header-cell>
                <mat-cell style="flex-grow: 3;" *matCellDef="let row"> {{row.formName}} </mat-cell>
            </ng-container> -->

            <ng-container matColumnDef="eventName">
                <mat-header-cell style="flex-grow: 3;" *matHeaderCellDef mat-sort-header> Event Name
                </mat-header-cell>
                <mat-cell style="flex-grow: 3;" *matCellDef="let row"> {{row.formName}} </mat-cell>
            </ng-container>

            <ng-container matColumnDef="OrgName">
                <mat-header-cell style="flex-grow: 3;" *matHeaderCellDef mat-sort-header> Organization Name
                </mat-header-cell>
                <mat-cell style="flex-grow: 3;" *matCellDef="let row"> {{row.orgName}} </mat-cell>
            </ng-container>

            <ng-container matColumnDef="dateRequest">
                <mat-header-cell style="flex-grow: 2;" *matHeaderCellDef mat-sort-header>Request Date</mat-header-cell>
                <mat-cell style="flex-grow: 2;" *matCellDef="let row"> {{row.dateRequest | date: 'MM-dd-yyyy'}}
                </mat-cell>
            </ng-container>

            <ng-container matColumnDef="status">
                <mat-header-cell style="flex-grow: 2;" *matHeaderCellDef mat-sort-header> Status </mat-header-cell>
                <mat-cell style="flex-grow: 2;" *matCellDef="let row" [ngClass]="getStatusClass(row.status)">
                    {{row.status}} </mat-cell>
            </ng-container>

            <ng-container matColumnDef="statusDescrAdmin">
                <mat-header-cell style="flex-grow: 2;" *matHeaderCellDef mat-sort-header> Status Admin
                </mat-header-cell>
                <mat-cell style="flex-grow: 2;" *matCellDef="let row" [ngClass]="getStatusClass(row.statusDescrAdmin)">
                    {{row.statusDescrAdmin}} </mat-cell>
            </ng-container>

            <ng-container matColumnDef="emailDate">
                <mat-header-cell style="flex-grow: 2;" *matHeaderCellDef mat-sort-header>Email Date</mat-header-cell>
                <mat-cell style="flex-grow: 2;" *matCellDef="let row"> {{row.emailDate | date: 'MM/dd/yyyy h:mm a'}}
                </mat-cell>
            </ng-container>

            <!-- 
            <ng-container matColumnDef="uploadStatusCode">
                <mat-header-cell style="flex-grow: 2;" *matHeaderCellDef mat-sort-header> Status From OeBS </mat-header-cell>
                <mat-cell style="flex-grow: 2;" *matCellDef="let row" [ngClass]="getStatusClass(row.FormCCOeBS.uploadStatusCode)"> {{row.FormCCOeBS.uploadStatusCode}} </mat-cell>
            </ng-container> -->
            <!-- 
            <ng-container matColumnDef="OeBSStatus">
                <mat-header-cell style="flex-grow: 2;" *matHeaderCellDef mat-sort-header> Status From OeBS </mat-header-cell>
                <mat-cell style="flex-grow: 2;" *matCellDef="let row" [ngClass]="getStatusClass(row.FormCCOeBS.OeBSStatus)"> {{row.OeBSStatus}} </mat-cell>
            </ng-container> -->

            <ng-container matColumnDef="view">
                <mat-header-cell style="flex-grow: 1; justify-content:center;" *matHeaderCellDef></mat-header-cell>
                <mat-cell style="flex-grow: 1; justify-content:center;" *matCellDef="let row" style="text-align:right;">
                    <button mat-icon-button matTooltip="View" matTooltipShowDelay="200" (click)="selectRow(row)">
                        <mat-icon color="primary">folder_open</mat-icon>
                    </button>
                </mat-cell>
            </ng-container>

            <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
            <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
        </mat-table>
    </div>
    <div>
        <mat-paginator [pageSizeOptions]="[5, 10, 25, 100]"></mat-paginator>
    </div>

</div>